export function demoApi(c) {
    return {
        session: () => c.post('/public/demo/session', undefined, { anonymous: true }),
    };
}
//# sourceMappingURL=demo.js.map